import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

interface TooltipIconProps extends Omit<IconWrapperProps, "color"> {
  color?: string;
}

const TooltipIcon = ({ color, ...rest }: TooltipIconProps) => (
  <IconWrapper viewBox="0 0 16 17" width="16" height="17" {...rest}>
    <g fill="none" fillRule="evenodd">
      <g fill={color || "#776C64"}>
        <path
          d="M8 0c2.122 0 4.156.843 5.657 2.343C15.157 3.843 16 5.878 16 8s-.843 4.156-2.343 5.657C12.157 15.157 10.122 16 8 16s-4.156-.843-5.657-2.343C.843 12.157 0 10.122 0 8s.843-4.156 2.343-5.657C3.843.843 5.878 0 8 0zm0 1.548c-1.71 0-3.352.68-4.562 1.89C2.228 4.648 1.548 6.29 1.548 8c0 1.71.68 3.352 1.89 4.561 1.21 1.211 2.851 1.89 4.562 1.89 1.71 0 3.352-.679 4.562-1.89 1.21-1.21 1.89-2.85 1.89-4.561 0-1.71-.68-3.352-1.89-4.562-1.21-1.21-2.851-1.89-4.562-1.89zm.774 6.194v4.129H7.226v-4.13h1.548zm0-2.839c0 1.032-1.548 1.032-1.548 0s1.548-1.032 1.548 0z"
          transform="translate(-1434 -993) translate(-.288 128) translate(1108.288 119) translate(0 663) translate(0 36) translate(64 15.25) translate(72 4) translate(190 28)"
        />
      </g>
    </g>
  </IconWrapper>
);

export default memo(TooltipIcon);
